import React from 'react';
import { observer } from 'mobx-react-lite';
import './home-observer.scss';

export const HomeObserver: React.FC = observer(() => {
  const tools = [
    {
      name: 'Timer/Stopwatch',
      description: 'Time tracking with multiple timers and stopwatch functionality',
      path: '/timer',
      icon: '⏱️',
      color: '#ef4444'
    },
    {
      name: 'Ruler',
      description: 'Screen calibration tool for accurate measurements',
      path: '/ruler',
      icon: '📏',
      color: '#10b981'
    },
    {
      name: 'Scientific Calculator',
      description: 'Advanced calculator with scientific functions',
      path: '/calculator',
      icon: '🧮',
      color: '#8b5cf6'
    },
    {
      name: 'Notepad',
      description: 'Simple text editor with auto-save',
      path: '/notepad',
      icon: '📝',
      color: '#f59e0b'
    },
    {
      name: 'Unit Converter',
      description: 'Convert between various units of measurement',
      path: '/unit-converter',
      icon: '🔄',
      color: '#06b6d4'
    },
    {
      name: 'Currency Converter',
      description: 'Real-time currency exchange rates',
      path: '/currency-converter',
      icon: '💱',
      color: '#84cc16'
    }
  ];

  return (
    <div className="home">
      <div className="home__hero">
        <h1>General Tools</h1>
        <p>A collection of useful tools for everyday tasks</p>
      </div>

      <div className="home__tools">
        {tools.map(tool => (
          <a
            key={tool.path}
            href={tool.path}
            className="home__tool-card"
            style={{ '--tool-color': tool.color } as React.CSSProperties}
          >
            <div className="home__tool-icon">{tool.icon}</div>
            <h3 className="home__tool-name">{tool.name}</h3>
            <p className="home__tool-description">{tool.description}</p>
          </a>
        ))}
      </div>
    </div>
  );
});
